// RB-MY01-PalmGarden.web/src/components/PlantForm/components/FormSections/ImagesPublish.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionCard from '../SectionCard';
import { FormSectionProps } from '../../types';
import { sectionThemes } from '../../styles';

const ImagesPublish: React.FC<FormSectionProps> = ({ 
  plant
}) => {
  return (
    <SectionCard 
      title="Images & Publish" 
      icon={<i className={sectionThemes.imagesPublish.iconName} style={{ marginRight: '8px' }} />}
      theme={{ color: sectionThemes.imagesPublish.color }}
    >
      <Box sx={{ p: 2 }}>
        <Typography>
          Images & Publish section is under construction.
        </Typography>
      </Box>
    </SectionCard>
  );
};

export default React.memo(ImagesPublish);
